function changeSelector(elementClicked, selector) {
  let event = new Event("change");

  let select = document.querySelector(selector);
  if(!select) return false
  let indexOption = Array.from(select.options).find(
    (data) => data.value == elementClicked.value
  ).index;

  select.value = elementClicked.value;
  select.selectedIndex = indexOption;
  select.dispatchEvent(event);
}

function setEvents() {
  let inputsGeneral = document.querySelectorAll('input[name^="options"]');
  let inputsSize = document.querySelectorAll('input[name="options[Size]"]');
  let inputsLayout = document.querySelectorAll('input[name="options[Layout]"]');
  let inputsImageColor = document.querySelectorAll('input[name="options[Image Color]"]');
  let inputsColor = document.querySelectorAll(
    'input[name="properties[Frame-Color]"]'
  );

  inputsGeneral.forEach((element) => {
    element.addEventListener("change", () => {
      let typeAttribute = element.getAttribute('data-variant-type')
      if(!typeAttribute) return false
      changeSelector(element, `select[name="options[${typeAttribute}]"]`);
    });
  });
  inputsSize.forEach((element) => {
    element.addEventListener("change", () => {
      changeSelector(element, 'select[name="options[Size]"]');
    });
  });
  inputsLayout.forEach((element) => {
    element.addEventListener("change", () => {
      changeSelector(element, 'select[name="options[Layout]"]');
    });
  });
  inputsImageColor.forEach((element) => {
    element.addEventListener("change", () => {
      changeSelector(element, 'select[name="options[Image Color]"]');
    });
  });
  inputsColor.forEach((element) => {
    element.addEventListener("change", () => {
      changeSelector(element, 'select[name="properties[Frame Color]"]');
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setEvents();
});
